import React from "react";
import "../../styles/Tabella.css"


function TabellaSpa() {
    return(
        <div className="table-container">
            <table className="table table-bordered m-auto" style={{width: "20em"}}>
                <colgroup>
                    <col style={{ width: "14.287%", minWidth: "50px"}} />
                    <col style={{ width: "14.287%", minWidth: "50px" }} />
                </colgroup>
                <thead>
                <tr>
                    <th className="header-cell" scope="col">Giorno</th>
                    <th className="header-cell" scope="col">Orario</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td className="data-cell">dal lunedì al venerdì</td>
                    <td className="data-cell">10-22</td>
                </tr>
                <tr>
                    <td className="data-cell">sabato</td>
                    <td className="data-cell">10-19</td>
                </tr>
                <tr>
                    <td className="data-cell">domenica</td>
                    <td className="data-cell">9-13</td>
                </tr>
                </tbody>
            </table>
        </div>
    )
}

export default TabellaSpa